export const START_WORKING = "/capture/start_working_workstation";
export const STOP_WORKING = "/capture/stop_working_workstation";
export const WORKSTATION_INFO = "/capture/workstation_inf";
export const PARTS = "/capture/parts_from_workstation";
export const MOS = "/capture/manufacturing_orders";
export const PART_ACTIVATION = "/capture/part_activation";
export const WORKSTATION = "/capture/dashboard";
export const DEFECTS = "/dashboard/defects/defects_workstations.json";
export const PARTS_SAVED = "/capture/parts_saved";
export const SEND_PARTS = "/capture/parts";
export const TAGS_FROM_WORKSTATION = "/capture/tags_from_workstation";
export const DOWNTIMES = "/dashboard/downtimes";
export const LAST_DOWNTIME = "/capture/create_downtime_tag";
export const CATEGORIZED_DOWNTIMES = "/capture/categorized_downtimes";
export const UPTIME_MANUAL_CAPTURE = "/dashboard/uptimes/manual_capture";
export const CREATE_STANDARD_PACK = "/dashboard/create_standard_pack";
export const GET_STANDAR_PACK_UNPACKED = "/dashboard/standard_packs_unpacked";
export const CREATE_PALLET = "/dashboard/create_pallet";
export const WORKSTATIONS_AND_PARTS = "/capture/workstations_and_parts";
export const DOWNTIME_SPLITTED = "/capture/downtime_splitted";
export const MO_CAPTUREDS = "/manufacturing_orders_captureds";
export const LAST_SCHEDULE_PRODUCTION = "/capture/last_schedule_production";
export const COMPLETE_OF = "/manufacturing_orders/complete_of";
